/** Stub for the native `canvas` package — not needed in Vitest/jsdom. */
function createCanvas(width = 0, height = 0) {
  return {
    width,
    height,
    getContext: () => ({
      fillRect: () => {},
      clearRect: () => {},
      getImageData: () => ({ data: new Uint8ClampedArray(4) }),
      putImageData: () => {},
      createImageData: () => ({ data: new Uint8ClampedArray(4) }),
      drawImage: () => {},
      measureText: () => ({ width: 0 }),
    }),
    toBuffer: () => Buffer.alloc(0),
    toDataURL: () => "data:,",
  };
}

function loadImage() {
  return Promise.resolve({ width: 0, height: 0 });
}

class Image {
  width = 0;

  height = 0;

  src = "";
}

module.exports = {
  createCanvas,
  loadImage,
  Image,
};
